import { render } from "./ThemePage.vue?vue&type=template&id=4913bd0c&scoped=true"
import script from "./ThemePage.vue?vue&type=script&lang=js"
export * from "./ThemePage.vue?vue&type=script&lang=js"

import "./ThemePage.vue?vue&type=style&index=0&id=4913bd0c&lang=sass&scoped=true"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4913bd0c"]])

export default __exports__